import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Alert } from '@mui/material';
import api from '../api';
import { Rolle } from '../konto';

interface Props {
  onLogin: (token: string, name: string, rolle: Rolle) => void;
}

export default function Login({ onLogin }: Props) {
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState('');
  const [hinweis, setHinweis] = useState('');
  const [laden, setLaden] = useState(false);
  const [vergessen, setVergessen] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (laden) return;
    setLaden(true);
    setFehler('');
    try {
      const res = await api.post('/auth/login', { email: email.trim(), passwort });
      onLogin(res.data.token, res.data.name, res.data.rolle || 'admin');
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 401) setFehler('E-Mail oder Passwort falsch');
      else if (status === 429 || status === 400) setFehler(err.response.data?.fehler || 'Anmeldung nicht möglich');
      else setFehler('Server nicht erreichbar. Bitte Internetverbindung prüfen und erneut versuchen.');
      setLaden(false);
    }
  };

  const linkAnfordern = async (e: React.FormEvent) => {
    e.preventDefault();
    if (laden) return;
    setLaden(true);
    setFehler('');
    try {
      const res = await api.post('/auth/passwort-vergessen', { email: email.trim() });
      setHinweis(res.data?.hinweis || 'Falls die Adresse bekannt ist, wurde ein Link gesendet.');
      setVergessen(false);
    } catch {
      setFehler('Server nicht erreichbar. Bitte später erneut versuchen.');
    } finally { setLaden(false); }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5" px={2}>
      <Paper component="form" onSubmit={vergessen ? linkAnfordern : handleLogin} elevation={3} sx={{ p: 4, width: '100%', maxWidth: 360 }}>
        <Typography variant="h5" fontWeight="bold" mb={1} textAlign="center">
          Hotel Hohenlohe
        </Typography>
        <Typography variant="subtitle1" mb={3} textAlign="center" color="text.secondary">
          {vergessen ? 'Passwort vergessen' : 'Menüdatenbank'}
        </Typography>
        {fehler && <Alert severity="error" sx={{ mb: 2 }}>{fehler}</Alert>}
        {hinweis && !vergessen && <Alert severity="info" sx={{ mb: 2 }}>{hinweis}</Alert>}
        {vergessen && <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>Geben Sie Ihre E-Mail-Adresse ein. Sie bekommen einen Link, mit dem Sie ein neues Passwort festlegen.</Typography>}
        <TextField
          fullWidth autoFocus label="E-Mail" type="email" autoComplete="username" value={email}
          onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }}
        />
        {!vergessen && (
          <TextField
            fullWidth label="Passwort" type="password" autoComplete="current-password" value={passwort}
            onChange={e => setPasswort(e.target.value)}
            sx={{ mb: 3 }}
          />
        )}
        <Button fullWidth type="submit" variant="contained" size="large" disabled={laden || !email.trim() || (!vergessen && !passwort)}>
          {vergessen ? (laden ? 'Senden …' : 'Link senden') : (laden ? 'Anmelden …' : 'Anmelden')}
        </Button>
        <Button fullWidth size="small" sx={{ mt: 1 }} onClick={() => { setVergessen(v => !v); setFehler(''); setHinweis(''); }}>
          {vergessen ? 'Zurück zur Anmeldung' : 'Passwort vergessen?'}
        </Button>
      </Paper>
    </Box>
  );
}
